/* eslint-disable-next-line @typescript-eslint/no-restricted-imports  -- (https://aka.ms/OWALintWiki)
 * Using transaction to deprecate legacy satchel actions */
import { transaction } from 'owa-transaction';
import { mutatorAction } from 'satcheljs';
import type TabViewState from '../store/schema/TabViewState';
import { TabType, type TabState } from '../store/schema/TabViewState';
import getActiveContentTab from '../utils/getActiveContentTab';
import setTabIsShown from './setTabIsShown';
import { PerformanceDatapoint } from 'owa-analytics';
import { getTabHandler } from '../utils/TabHandler';
import { isFeatureEnabled } from 'owa-feature-flags';
import { errorThatWillCauseAlertAndThrow } from 'owa-trace';
import activateTabAction from './activateTabAction';
import { getModuleContextMailboxInfo } from 'owa-module-context-mailboxinfo';

export default function activateTab(viewState: TabViewState, isUserAction?: boolean): void {
    const dp = new PerformanceDatapoint('TabViewActivateTab', getModuleContextMailboxInfo(), {
        isVerbose: true,
        isScorecardEvent: true,
    });
    dp.addCustomData([viewState.type, isUserAction]);

    transaction(() => {
        setTabIsShown(viewState, true /*isShown*/);
        activateTabAction(viewState, isUserAction);

        switch (viewState.type) {
            case TabType.Primary:
            case TabType.OverflowMenu:
            case TabType.SecondaryReadingPane:
            case TabType.MailCompose:
            case TabType.FullOptions:
            case TabType.Reminders:
            case TabType.AddCalendars:
                if (
                    viewState.type === TabType.FullOptions &&
                    !isFeatureEnabled('acct-fullOptionsProjectionPopout')
                ) {
                    errorThatWillCauseAlertAndThrow(
                        'activateTab should NOT be called for FullOptions when acct-fullOptionsProjectionPopout flight is OFF'
                    );
                }

                if (viewState.state != 2) {
                    const activeTab = getActiveContentTab();

                    if (activeTab) {
                        updateTabMutator(activeTab, 1);
                        const handler = getTabHandler(activeTab.type);
                        if (handler?.onDeactivate) {
                            handler.onDeactivate(activeTab);
                        }
                    }

                    if (viewState) {
                        updateTabMutator(viewState, 2, false);
                        const handler = getTabHandler(viewState.type);
                        if (handler?.onActivate) {
                            handler.onActivate(viewState);
                        }
                    }
                }
        }
    });

    dp.end();
}

const updateTabMutator = mutatorAction(
    'updateTab',
    (tab: TabViewState, state: TabState, blink?: boolean) => {
        tab.state = state;
        if (blink !== undefined) {
            tab.blink = blink;
        }
    }
);
